import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { add, chevronBackOutline, chevronForwardOutline, refresh } from 'ionicons/icons';
import { ToolbarProps } from 'react-big-calendar';

type Props = ToolbarProps & {
  canCreate: boolean;
  hideRefresh: boolean;
  onCreate: () => void;
  onRefresh: () => void;
};

const AgendaToolbar: React.FC<Props> = ({ label, view, views, onNavigate, onView, localizer, canCreate, hideRefresh, onCreate, onRefresh }) => (
  <div className="agenda-calendar-toolbar">
    <div className="agenda-period">
      <div className="agenda-navigation" role="group" aria-label="Navegar pelo calendário">
        <button type="button" aria-label="Período anterior" onClick={() => onNavigate('PREV')}><IonIcon icon={chevronBackOutline} aria-hidden="true" /></button>
        <button type="button" onClick={() => onNavigate('TODAY')}>Hoje</button>
        <button type="button" aria-label="Próximo período" onClick={() => onNavigate('NEXT')}><IonIcon icon={chevronForwardOutline} aria-hidden="true" /></button>
      </div>
      <h1 aria-live="polite">{label}</h1>
    </div>
    <div className="agenda-actions">
      <IonButton className="agenda-refresh" fill="outline" aria-label="Atualizar agenda" title="Atualizar agenda" hidden={hideRefresh} onClick={onRefresh}>
        <IonIcon icon={refresh} slot="start" aria-hidden="true" /><span>Atualizar</span>
      </IonButton>
      <IonButton className="agenda-new-desktop" hidden={!canCreate} onClick={onCreate}><IonIcon icon={add} slot="start" aria-hidden="true" />Novo agendamento</IonButton>
    </div>
    <div className="agenda-views" role="group" aria-label="Visualização do calendário">
      {Array.isArray(views) && views.map(name => (
        <button type="button" key={name} aria-pressed={view === name} onClick={() => onView(name)}>{localizer.messages[name]}</button>
      ))}
    </div>
  </div>
);

export default AgendaToolbar;
